
import Vue, { PropType } from 'vue'
import {Box, Gateway} from '@/models'

import ToiletBoxListHeader from './ToiletBoxListHeader.vue'
import ToiletBoxListItem from './ToiletBoxListItem.vue'

export default Vue.extend({
  name: 'ToiletBoxList',

  props: {
    boxes: Array as PropType<Array<Box>>,
    gateway: Object as PropType<Gateway>,
  },

  components: {
    ToiletBoxListHeader,
    ToiletBoxListItem
  },
})
